import { FormEvent, useContext, useState } from "react";
import { Button, CompanyLogo, Input } from "../../../../Components/Atoms";
import { Form } from "@unform/web";
// import { Container } from "../style";
import api from "../../../../Services/api";
import { MyFirstAccessContext } from "..";
import { useHistory } from "react-router-dom";
import { useToast } from "../../../../Hooks/toast";
import { TextField, Typography } from "@mui/material";
import { VerificationContainer } from "../../VerificationCode/styles";

export const SendEmail = () => {

    const history = useHistory();

    const { sendVerificationCode } = useContext(MyFirstAccessContext);

    const { addToast } = useToast();

    const [username, setUsername] = useState('');

    const [error, setError] = useState('');

    const handleSubmit = async (e: FormEvent) => {

        e.preventDefault();

        if(!username) return setError('Obrigatório');

        const isEmail = username.includes('@');

        if(isEmail) {
            if(!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(username)) return setError('Email inválido');
        }
        else {
            if(![11,14].includes(username.length)) return setError('Documento faltando caractéres');

            if(/\D/gi.test(username)) return setError('Documento só pode ter somente números');
        }

        setError('');

        const isSuccessfulResponse = await sendVerificationCode(username);

        if(isSuccessfulResponse === true) 
            return history.push('/auth/my-first-access/validate-code');

       else if(isSuccessfulResponse === false) {
            return addToast({
                title: 'Erro',
                description: 'Erro ao enviar código de validação',
                type: 'error'
            });
        }

        return addToast({
            title: 'Erro',
            description: isSuccessfulResponse,
            type: 'error'
        });
    }

    return (
        <VerificationContainer>
            <CompanyLogo width={200} height={60} />
            <Typography mb={2}>Para realizar o seu primeiro acesso, informe o seu email ou documento</Typography>
            <form onSubmit={handleSubmit}>
                <TextField 
                    type="text"
                    name="username"
                    helperText={error}
                    error={!!error}
                    fullWidth
                    sx={{ mb: 2 }}
                    placeholder="Email ou documento"
                    onChange={e => setUsername(e.currentTarget.value)}
                />

                <Button type="submit">
                    Avançar
                </Button>
            </form>
        </VerificationContainer>
    )
}